<template>
    <div>
        <Dialog :show="show" :has-backdrop="true" :show-close-button="true" @close="$emit('close')" width="800px">
            <div style="width:100%; min-height: 600px">
                <h4>Preset auswählen</h4>
                <Dropdown label="Gruppe" :delete-selected="false"
                          :items="groups" initial="Keine Gruppe"
                          :select-on-click="true"
                          @enter="groupSelected" :style="{marginBottom:'20px'}"></Dropdown>
                <div class="content">
                    <div class="checkboxContainer">
                        <Checkbox id="private" title="Private" v-model="searchData.private"></Checkbox>
                        <Checkbox id="public" title="Public" v-model="searchData.public"></Checkbox>
                        <Checkbox id="shared" title="Shared" v-model="searchData.shared"></Checkbox>
                    </div>
                    <AdaTableClient sort-key="name" :columns="columns" :rows="presets" :transformers="transformers"
                                    @rowClicked="rowClicked" :searchData="searchData"
                                    :data-loading="presetLoading"></AdaTableClient>
                </div>
                <!--<LoaderDialog :show="deleteLoader">Bitte warten. Preset <b>{{clickedRow.name}}</b> wird gelöscht.
                </LoaderDialog>-->
            </div>
        </Dialog>
        <SharedPresetsDialog :show="showSharedPresets" @close="showSharedPresets = false"></SharedPresetsDialog>
        <Confirm :show="showDeleteConfirm" :closeable="true" :ok-loading="deleteLoader" @close="showDeleteConfirm = false"
                 title="Preset löschen" @onok="deletePreset" @oncancel="showDeleteConfirm = false"
        >
            <div style="margin-bottom:10px">Preset <b>{{presetName}}</b> wirklich löschen?</div>
            <div>Diese Aktion kann nicht wieder Rückgangig gemacht werden.</div>
        </Confirm>
    </div>
</template>

<script>
    import Dialog from "../../components/dialogs/Dialog";
    import Dropdown from "../../components/inputs/DropDown";
    import Checkbox from "../../components/inputs/Checkbox";
    import SharedPresetsDialog from "./SharedPresetsDialog";
    import AdaTableClient from "../../components/dataTable/AdaTableClient";
    //import LoaderDialog from "../../components/dialogs/LoaderDialog";
    import Confirm from "../../components/dialogs/Confirm";

    export default {
        name: "SelectPresetDialog",
        components: {Confirm, AdaTableClient, SharedPresetsDialog, Checkbox, Dropdown, Dialog}, //LoaderDialog,
        props: {
            show: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                showSharedPresets: false,
                showDeleteConfirm: false,
                selectedGroup: null,
                clickedRow: null,
                searchData: {
                    group: null,
                    private: false,
                    public: false,
                    shared: false,
                },
                columns: [
                    //param.name = name of route param , param.value = the prop name in the dataTable row
                    {
                        label: 'Gruppe',
                        name: 'group_name',
                        route: {name: 'mydeals', params: [{name: 'id', value: 'id'}]}
                    },
                    {
                        label: 'Name',
                        name: 'name',
                        route: {name: 'mydeals', params: [{name: 'id', value: 'id'}]}
                    },
                    {
                        label: 'Status',
                        name: 'visibility',
                        route: {name: 'mydeals', params: [{name: 'id', value: 'id'}]}
                    },
                    {
                        label: 'Ersteller',
                        name: 'author_name',
                        route: {name: 'mydeals', params: [{name: 'id', value: 'id'}]}
                    },
                    {label: 'Aktion', name: 'action', width: '90px'}
                ],
                transformers: [
                    {
                        propName: 'action',
                        transform: function (value) {
                            let res = '';
                            value.forEach(action => {
                                switch (action) {
                                    case 'delete':
                                        res += '<span style="cursor: pointer" data-type="delete" class="margin-right hover-highlight icon icon-delete"></span>';
                                        break;
                                    case 'share':
                                        res += '<span style="cursor: pointer" data-type="share" class="margin-right hover-highlight icon icon-share"></span>';
                                        break;
                                }
                            });
                            return res;
                        }
                    }
                ],
            }
        },
        mounted() {
            if (this.groups.length === 1) {
                this.fetchGroups();
            }
            if (this.vuexState.presets.length === 0) {
                this.fetchPresets();
            }
        },

        computed: {
            vuexState() {
                return this.$store.state.presets;
            },
            presets() {
                return this.$store.getters['presets/selectablePresets'];
            },
            deleteLoader() {
                return this.vuexState.presetsTableData.showDeleteLoader;
            },
            presetLoading() {
                return this.vuexState.presetsTableData.presetLoading;
            },
            presetName() {
                return this.clickedRow ? this.clickedRow.name : '';
            },
            groups() {
                return this.$store.getters['presets/groups'];
            }
        },
        methods: {
            async fetchGroups() {
                await this.$store.dispatch('presets/fetchGroups', true);
            },
            async fetchPresets() {
                await this.$store.dispatch('presets/fetch', true);
            },
            async deletePreset() {
                await this.$store.dispatch('presets/deletePreset', {id: this.clickedRow.id});
                this.showDeleteConfirm = false;
            },
            groupSelected(group) {
                this.searchData.group = group;
            },
            rowClicked(data) {
                this.clickedRow = data.row;
                if (data.column.name === 'action') {
                    let dataType = data.event.target.getAttribute('data-type');
                    if (dataType === 'delete') {
                        this.showDeleteConfirm = true;
                    } else if (data.event.target.getAttribute('data-type') === 'share') {
                        this.$store.commit('presets/setSelectedPreset', {data: data.row});
                        this.showSharedPresets = true;
                    }
                } else {
                    this.$root.$emit('showSelectPresetDialog', false);
                }
            }
        },
        watch:{
            show(value){
                if(value){
                    this.fetchPresets();
                }
            }
        }
    }
</script>

<style scoped>
    .content {
        position: relative;
    }

    .checkboxContainer {
        position: absolute;
        top: 10px;
        left: 280px;
    }
</style>